export default {
  "content": "<path fill=\"#0E864F\" d=\"M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10zm14.523-1.727a1.096 1.096 0 000-1.546 1.096 1.096 0 00-1.546 0L8.75 10.953 7.023 9.227a1.096 1.096 0 00-1.546 0 1.096 1.096 0 000 1.546l2.5 2.5a1.096 1.096 0 001.546 0l5-5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};